import { render, staticRenderFns } from "./MonthlySocsoExport.vue?vue&type=template&id=0572d45a"
import script from "./MonthlySocsoExport.vue?vue&type=script&lang=js"
export * from "./MonthlySocsoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports